module.exports = __webpack_public_path__ + "img/meta-whats-new.f89e30b.jpg";